"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SalesDashboardExcelFileDTO_1 = require("../model/SalesDashboardExcelFileDTO");

var SalesDashboardExcelFileDTOConverter_1 = require("./SalesDashboardExcelFileDTOConverter");

var SalesDashboardExcelFileDTOConverterImpl =
/*#__PURE__*/
function (_SalesDashboardExcelF) {
  _inherits(SalesDashboardExcelFileDTOConverterImpl, _SalesDashboardExcelF);

  function SalesDashboardExcelFileDTOConverterImpl() {
    _classCallCheck(this, SalesDashboardExcelFileDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardExcelFileDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SalesDashboardExcelFileDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SalesDashboardExcelFileDTO_1.SalesDashboardExcelFileDTO(SalesDashboardExcelFileDTO_1.SalesDashboardExcelFileDTO.schema.id.valueOf(conversions.documentToClassId(source)), SalesDashboardExcelFileDTO_1.SalesDashboardExcelFileDTO.schema.fileId.valueOfField(source), SalesDashboardExcelFileDTO_1.SalesDashboardExcelFileDTO.schema.filename.valueOfField(source), SalesDashboardExcelFileDTO_1.SalesDashboardExcelFileDTO.schema.uploadDate.valueOfField(source), SalesDashboardExcelFileDTO_1.SalesDashboardExcelFileDTO.schema.note.valueOfField(source));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        filename: source.filename,
        fileId: source.fileId,
        uploadDate: conversions.fromDate(source.uploadDate),
        note: source.note
      });
      return result;
    }
  }]);

  return SalesDashboardExcelFileDTOConverterImpl;
}(SalesDashboardExcelFileDTOConverter_1.SalesDashboardExcelFileDTOConverter);

exports.SalesDashboardExcelFileDTOConverterImpl = SalesDashboardExcelFileDTOConverterImpl;